<template>
  <div>
    <div v-if="numOfPages > 1" class="columns is-centered mb-4">
      <div class="column has-text-centered is-narrow">
        <button class="button is-rounded pagination-button" @click="decreasePage()"><i class="fas fa-chevron-left"></i></button>
      </div>
      <div class="column has-text-centered is-narrow">
        <nav class="pagination is-rounded" role="navigation" aria-label="pagination">
          <ul class="pagination-list">
            <li v-for="(pagination, index) in numOfPages" :key="index">
              <a @click="pageSwitch(pagination)" class="pagination-link" aria-label="Goto page 1">{{pagination}}</a>
            </li>
          </ul>
        </nav>
      </div>
      <div v-if="numOfPages > 1" class="column has-text-centered is-narrow">
        <button class="button pagination-button is-rounded" @click="increasePage()"><i class="fas fa-chevron-right"></i></button>
      </div>
    </div>
  </div>
</template>

<script>
// import slugify from "slugify";
import { mapState, mapActions, mapMutations } from "vuex";
export default {
    data() {
        return {
          page_number: Number,
        }
    },
    computed: {
      gym_number_per_page() {
        return this.$store.state.gym_number_per_page;
      },
      search_value() {
        return this.$store.state.search_value;
      },
      ...mapState(['selected_range', 'selectedPageNumber', 'numOfPages']),
    },
    methods: {
      ...mapActions(['findGyms']),
      ...mapMutations(['incrementPageNumber', 'decrementPageNumber', 'storePageNumber', 'storeNumOfPages']),
      pageSwitch(page) {
        this.storePageNumber(page)
        // this.$router.push({name: 'search', query: {search: slugify(this.search_value), page : page}, params: { range: this.selected_range}} );
      },
      increasePage() {
        if(this.selectedPageNumber < this.numOfPages){
          this.incrementPageNumber();
        }
      },
      decreasePage() {
        if(this.selectedPageNumber > 1){
          this.decrementPageNumber();
        }
      }
    },
    watch: {
      async selectedPageNumber() {
        await this.findGyms();
      }
    }
    ,
    mounted() {
      // if(this.$route.query.page <= this.page_number){
      //   this.storePageNumber(this.$route.query.page);
      // } else {
      //   this.$router.push({name: 'search', query: {search: slugify(this.search_value), page : 1}, params: { range: this.selected_range}} );
      // }
    }

};
</script>

<style scoped>
.pagination-button {
  width: 40px; 
  height: 40px
}
</style>